import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, Overline } from "@/components/Reveal";
import ProductCard from "@/components/ProductCard";

export default function Bestsellers() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data.products));
  }, []);

  return (
    <section className="relative bg-black py-24 lg:py-32" id="products" data-testid="bestsellers-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
            <div>
              <Overline>The Line-Up</Overline>
              <h2 className="mt-3 font-display text-6xl leading-none tracking-tight text-cream sm:text-7xl lg:text-8xl">
                OUR <span className="text-gold-gradient">BESTSELLERS</span>
              </h2>
              <p className="mt-4 max-w-md text-white/50">
                Eight bold ways to snack smarter. Every jar is packed fresh, protein-rich and
                unmistakably Dignity.
              </p>
            </div>
            <Link to="/shop" data-testid="view-all-products"
              className="group flex items-center gap-2 font-oswald text-sm uppercase tracking-[0.15em] text-gold">
              View All Products
              <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
